function addFbclid() {
  var fbclidFormFields = ["event_booking_fbclid", "issue_fbclid"]; // all possible fbclid form field ids here
  var currFbclidFormField;

  fbclidFormFields.forEach(function (field) {
    if (document.getElementById(field)) {
      currFbclidFormField = document.getElementById(field);
    }
  });

  var fbclid = window.fbclid;

  if (currFbclidFormField && fbclid) {
    currFbclidFormField.value = fbclid;
  }
}

document.addEventListener("turbo:load", addFbclid);